import MedicationCard from "./cards/medication-card";
import NoPreviewCard from "./cards/no-preview-card";
import { useQuery } from "@tanstack/react-query";

import { todayQuickActionsEncountersQueryOptions } from "../api/queries";
import { QuickActionCardSkeleton } from "./cards/quick-action-card-skeleton";
import { useParams } from "@tanstack/react-router";
import { getApiProgram } from "~/lib/utils";

const Medications = () => {
    const {program} = useParams({strict: false})
    const apiProgram = getApiProgram(program ?? "")
    const { data, isLoading } = useQuery(todayQuickActionsEncountersQueryOptions({
        limit: 1, 
        skip: 0, 
        type: "refill",
        // date_filter: "today",
        program: apiProgram,
        type_sort_order: "refill",
        status: "unresolved",
        sort: "new_old"
    }));

    return (
        <div className="flex flex-col gap-4">
            {isLoading ? (<QuickActionCardSkeleton />) : data ? (
                <MedicationCard
                    item={data as any}
                    program={program ?? ""}
                />
            ) : (
                <NoPreviewCard
                    icon="/assets/notifications.svg"
                    title="Nothing to Display"
                    description="You have no encounters to see today, when you do, they will appear here"
                    className="w-full h-[440px]"
                />
            )}
        </div>
    )
}

export default Medications;